
import { notification } from "antd";
import { IconType, NotificationPlacement } from "antd/lib/notification/interface";

const customNotification = (title: string, message: string, ico?: IconType, duration?: number, placement?: NotificationPlacement) => {
    notification[ico ?? 'info']({
        message: title,
        description: message,
        placement: placement ?? 'bottomLeft',
        duration: duration ?? 10
    });
}

const customNotificationMultipleMessage = (title: string, messages: Array<string>, ico?: IconType, duration?: number, placement?: NotificationPlacement) => {
    notification[ico ?? 'info']({
        message: title,
        description: messages.map((message) => {
            return (<div >{message}</div>);
        }),
        placement: placement ?? 'bottomLeft',
        duration: duration ?? 10
    });
}


export {
    customNotification,
    customNotificationMultipleMessage
}